


















































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { StripeElement, StripeElements } from 'vue-stripe-elements-plus';
import { IRecipient } from '@signing-page/documents/types/recipient';
import { IEntity } from '@signing-page/entity/types/entity';
import { IDocument } from '@signing-page/documents/types/document';
import { IIntegration } from '@signing-page/integrations/types/integration';
import { IStripeTokenResponse } from '@signing-page/integrations/types/stripe-token-response';
import { ICurrency } from '@/types/Currency';
import { getCurrency, formatCurrency } from '@/common/currency';
import StripeService from '@signing-page/integrations/services/stripe.service';
import '@stripe/stripe-js';
import { EButtonType } from '@lib-ui/components/base-button/types/enums/button-type';

@Component({
  data: () => ({
    EButtonType,
  }),
  components: {
    StripeElement,
    StripeElements,
  },
})
export default class Stripe extends Vue {
  @Prop() recipient!: IRecipient;
  @Prop() entity!: IEntity;
  @Prop() document!: IDocument;
  @Prop() stripeIntegration!: IIntegration;
  @Prop() authId!: string;

  loading = false;
  success = false;
  error = '';
  complete = false;
  stripeFocus = false;
  cardOptions = {
    style: {
      base: {
        iconColor: '#f2994a',
        color: '#3b3b3b',
      },
    },
  };

  get showStripe(): boolean {
    return !this.success && !this.loading;
  }

  get title(): string {
    if (this.success) {
      return '';
    }
    return this.$t('pay-with-stripe').toString();
  }

  get stripeKey(): string {
    return this.stripeIntegration.metaData_1;
  }

  get currency(): string {
    return this.entity.currency;
  }

  get amount(): number {
    return Math.round(this.document.value * 100);
  }

  get description(): string {
    return this.document.name;
  }

  get name(): string {
    return this.entity.name;
  }

  get email(): string {
    return this.recipient.email;
  }

  get value(): string {
    const currency: ICurrency = getCurrency(this.entity.currency);
    const value: string = formatCurrency(this.document.value, currency);
    return `${this.$t('amount-to-pay')}: ${value}`;
  }

  handleClose() {
    this.$emit('close');
  }

  handleFocus() {
    this.stripeFocus = true;
  }

  handleBlur() {
    this.stripeFocus = false;
  }

  async submit() {
    const groupComponent = this.$refs.elms;
    const cardComponent = this.$refs.card;
    const cardElement = cardComponent['stripeElement'];
    try {
      const { token } = await groupComponent['instance'].createToken(cardElement);
      if (!token) {
        this.handleFailure();
        return;
      }
      this.tokenCreated(token);
    } catch (e) {
      this.handleFailure();
    }
  }

  tokenCreated(token: IStripeTokenResponse) {
    this.loading = true;
    if (this.stripeIntegration.hasToken) {
      return this.reportCharge(token);
    }
    this.handleSuccess(token);
  }

  async reportCharge(token: IStripeTokenResponse) {
    const success: boolean = await StripeService.reportCharge(
      this.document.id,
      this.recipient.id,
      this.authId,
      token.id,
      this.email,
      this.amount
    );
    if (success) {
      return this.handleSuccess(token);
    }
    return this.handleFailure();
  }

  handleChange({ complete }: { complete: boolean }) {
    this.complete = complete;
  }

  handleSuccess(token: IStripeTokenResponse) {
    const { externalUrl } = this.stripeIntegration;
    if (externalUrl) {
      return this.redirect(externalUrl, token);
    }
    this.loading = false;
    this.success = true;
  }

  redirect(url: string, token: IStripeTokenResponse) {
    const redirectUrl = `${url}?token_id=${escape(token.id)}&token_email=${escape(token.email)}`;
    window.location.assign(redirectUrl);
  }

  handleFailure() {
    this.error = this.$t('stripe-payment-error').toString();
    this.loading = false;
  }
}
